import { useEffect, useState, Fragment } from 'react';
import { Table, Card, Space, Title, Text } from '@mantine/core';

const SummaryCard = (props) => {
    return (
        <Card>
            <Title order={3}>Summary</Title>
            <Space h="md" />
            <div>
                {(props.summary ? props.summary.replace(/>/g, ' ') : 'No summary available.').split('<').map((line, index) => (
                    <Fragment key={index}>{line}<br/></Fragment>
                ))}
            </div>
        </Card>
    )
}

export default SummaryCard;